export default "/EncodeSans-Bold.de844897-895eb9.ttf";